<template>
  <div class="homepage">
    <!-- Header Section -->
    <AppHeader />

    <!-- Main Content -->
    <main class="main-content">
      <!-- Hero Section -->
      <section class="hero">
        <div class="container">
          <div class="hero-content">
            <div class="hero-text">
              <!-- <p class="hero-subtitle">Get quick and cheap car insurance quotes today! Cheapest rates as low as <strong>$19/mo+</strong></p> -->
              <h1 class="hero-title">Time to Save Money on Car Insurance</h1>
              <h2 class="hero-description">Compare quotes for the best price</h2>
            </div>
            
            <div class="search-section">
              <div class="search-form">
                <div class="search-input-group">
                  <input 
                    type="text" 
                    id="zipcode"
                    v-model="zipCode" 
                    placeholder="Enter Zip Code"
                    maxlength="5"
                    @input="validateZipCode"
                    class="zip-input"
                  />
                  <button class="search-btn" @click="searchQuotes">Search</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Simple Coverage Section -->
      <section class="simple-coverage">
        <div class="container">
          <h2 class="simple-coverage-title">Simple and Affordable Coverage. Complete Protection.</h2>
        </div>
      </section>

      <!-- Insurance Competition Section -->
      <section class="insurance-competition">
        <div class="container">
          <div class="competition-content">
            <div class="competition-text">
              <h2 class="competition-title">Let Insurance Companies Compete for You.</h2>
              <p class="competition-description">Every insurance carrier can be different. So let's find you the best. We will go over the pros and cons, specific plans, and ratings for 30 companies. Compare the top companies directly and get down to the nuts and bolts of, it. Get quotes to compare, and ensure that you are getting the best coverage for the best price.</p>
              <a href="#" class="btn btn-primary get-started-btn">Get Started</a>
            </div>
            <div class="competition-image">
              <img :src="carImage" alt="Car Insurance Comparison" class="car-image" loading="lazy" width="500" height="333"/>
            </div>
          </div>
        </div>
      </section>
    </main>

    <!-- Footer Section -->
    <footer class="footer">
      <div class="container">
        <div class="footer-content">
          <div class="footer-logo">
            <img :src="logo" alt="PolicyVista" class="footer-logo-img" />
          </div>
          
          <div class="footer-disclaimer">
            <p>policyvista.com is an online insurance referral site. We match and directly connect consumers with insurance companies and agents across the US. Our site does not provide quotes directly to consumers and is not in any way affiliated with any of the insurance carriers. We do not provide insurance and we do not represent any specific insurance provider or automobile company. All trademarks and copyrights are the property of their respective owners. All articles on this website are for information purposes only. This website contains affiliate marketing links and phone numbers which means that the operators of this site may get paid commission on sales of the products or services advertised. policyvista.com provides access to independent auto insurance services and acts as an affiliate to these services. Your access to this website is subject to its</p>
          </div>
          
          <div class="footer-terms">
            <h3>Terms and Conditions</h3>
            <p class="california-notice">California residents only:</p>
            <p class="do-not-sell"><strong>Do not sell my info.</strong></p>
          </div>
          
          <div class="footer-copyright">
            <p>© 2013 – 2025 policyvista.com. All Rights Reserved.</p>
          </div>
          
          <div class="footer-links">
            <div class="footer-link">Privacy Policy</div>
            <div class="link-separator">|</div>
            <div class="footer-link">Terms & Conditions</div>
            <div class="link-separator">|</div>
            <div class="footer-link">SMS Terms</div>
            <div class="link-separator">|</div>
            <div class="footer-link">Disclaimer</div>
            <div class="link-separator">|</div>
            <div class="footer-link">Unsubscribe</div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue'
import { submitDataAndLog, initHomepageVisit } from '@/utils/localStorage'
import bannerImage from '@/assets/images/banner.jpeg'
import carImage from '@/assets/images/car-image.jpg'
import logo from '@/assets/images/logo.png'

export default {
  name: 'HomePage',
  components: {
    AppHeader
  },
  data() {
    return {
      zipCode: '',
      bannerImage,
      carImage,
      logo,
      autoRedirectTimer: null
    }
  },
  mounted() {
    // 首页访问时强制更新localStorage的click_id和task_timestamp
    initHomepageVisit()
  },
  methods: {
    validateZipCode() {
      this.zipCode = this.zipCode.replace(/\D/g, '').slice(0, 5)
      
      // 如果达到5位数字，启动自动跳转定时器
      if (this.zipCode.length === 5) {
        this.startAutoRedirect()
      } else {
        this.clearAutoRedirect()
      }
    },
    
    startAutoRedirect() {
      // 清除之前的定时器
      this.clearAutoRedirect()
      
      // 1秒后自动跳转
      this.autoRedirectTimer = setTimeout(() => {
        this.navigateToYear()
      }, 1000)
    },
    
    clearAutoRedirect() {
      if (this.autoRedirectTimer) {
        clearTimeout(this.autoRedirectTimer)
        this.autoRedirectTimer = null
      }
    },
    
    searchQuotes() {
      if (this.zipCode.length === 5) {
        this.navigateToYear()
      } else {
        alert('Please enter a valid 5-digit zip code')
      }
    },
    
    async navigateToYear() {
      // 保存数据到localStorage
      this.saveQuoteData()
      
      // 提交数据并记录页面提交事件
      await submitDataAndLog('home')
      
      // 跳转到year页面
      this.$router.push({
        name: 'Year',
        query: { zip: this.zipCode }
      })
    },
    
    saveQuoteData() {
      const quoteData = {
        zip_code: this.zipCode,
        host_name: "policyautoquotes.com",
        car_use: "",
        annual_distance: "",
        coverage_type: "",
        own_rent: "",
        has_insurance: "",
        months_insured: "",
        accidents: "0",
        violations: "0",
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        birthday: "",
        gender: 2,
        marital_status: "",
        address: "",
        city: "",
        state: "",
        military: "",
        car_year: "",
        car_make: "",
        car_model: "",
        car_distance: "",
        owned_leased: "",
        vehicles: []
      }
      
      localStorage.setItem('quoteData', JSON.stringify(quoteData))
    }
  },
  
  beforeUnmount() {
    // 组件销毁前清除定时器
    this.clearAutoRedirect()
  }
}
</script>

<style scoped>
/* Page Layout */
.homepage {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
}

/* Hero Styles */
.hero {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  padding: 4rem 0;
  text-align: center;
  background-image: url('@/assets/images/background.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 60vh;
  color: white;
}

.hero-subtitle {
  font-size: 1.2rem;
  color: #666;
  margin-bottom: 1rem;
}

.hero-title {
  font-size: 3rem;
  font-weight: 700;
  /* color: #333; */
  margin-bottom: 1rem;
  line-height: 1.2;
}

.hero-description {
  font-size: 1.5rem;
  /* color: #666; */
  margin-bottom: 2rem;
  font-weight: 400;
}

.search-section {
  max-width: 600px;
  margin: 130px auto;
}

.search-form {
  width: 100%;
}

.search-input-group {
  display: flex;
  background: white;
  border-radius: 50px;
  box-shadow: 0 8px 30px rgba(0,0,0,0.15);
  overflow: hidden;
  border: 1px solid #e9ecef;
}

.zip-input {
  flex: 1;
  padding: 20px 30px;
  border: none;
  background: transparent;
  font-size: 18px;
  outline: none;
  color: #666;
  font-weight: 400;
}

.zip-input::placeholder {
  color: #999;
  font-size: 18px;
}

.search-btn {
  padding: 20px 40px;
  background: #06942b;
  color: white;
  border: none;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s ease;
  white-space: nowrap;
}

.search-btn:hover {
  background: #218838;
}

/* Simple Coverage Styles */
.simple-coverage {
  background-image: url('@/assets/images/banner.jpeg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 4rem 0;
  position: relative;
  text-align: center;
}

.simple-coverage::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 1;
}

.simple-coverage .container {
  position: relative;
  z-index: 2;
}

.simple-coverage-title {
  color: white;
  font-size: 2.5rem;
  font-weight: 700;
  line-height: 1.2;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  max-width: 800px;
  margin: 0 auto;
}

/* Insurance Competition Styles */
.insurance-competition {
  padding: 4rem 0;
  background: white;
}

.competition-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: center;
}

.competition-text {
  padding-right: 2rem;
}

.competition-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 1.5rem;
  line-height: 1.2;
}

.competition-description {
  font-size: 1.1rem;
  color: #666;
  line-height: 1.6;
  margin-bottom: 2rem;
}

.get-started-btn {
  display: inline-block;
  padding: 1rem 2rem;
  font-size: 1.1rem;
  font-weight: 600;
}

.competition-image {
  text-align: center;
}

.car-image {
  width: 100%;
  max-width: 500px;
  height: auto;
  border-radius: 12px;
}

.btn-primary {
  background-color: #06942b;
}


/* Footer Styles */
.footer {
  background: #f8f9fa;
  padding: 3rem 0 2rem;
  text-align: center;
}

.footer-content {
  max-width: 800px;
  margin: 0 auto;
}

.footer-logo {
  margin-bottom: 2rem;
}

.footer-logo-img {
  height: 60px;
  width: auto;
}

.footer-disclaimer {
  margin-bottom: 2rem;
}

.footer-disclaimer p {
  font-size: 0.9rem;
  line-height: 1.6;
  color: #666;
  text-align: center;
}

.footer-terms {
  margin-bottom: 2rem;
}

.footer-terms h3 {
  font-size: 1.3rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 1rem;
}

.california-notice {
  font-size: 0.9rem;
  color: #666;
  margin-bottom: 0.5rem;
}

.do-not-sell {
  font-size: 1rem;
  color: #333;
  margin-bottom: 0;
}

.footer-copyright {
  margin-bottom: 2rem;
}

.footer-copyright p {
  font-size: 0.9rem;
  color: #999;
}

.footer-links {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.3rem;
}

.footer-link {
  color: #999;
  font-size: 0.9rem;
  cursor: default;
}

.link-separator {
  color: #999;
  font-size: 0.9rem;
  margin: 0.2rem 0;
}

/* Responsive Design */
@media (max-width: 768px) {


  .hero-title {
    font-size: 2rem;
  }

  .hero-description {
    font-size: 1.2rem;
  }

  .search-section {
    margin: 80px auto;
    max-width: 95%;
  }

  .search-input-group {
    border-radius: 10px;
  }

  .zip-input {
    padding: 16px 20px;
    font-size: 16px;
    min-width: 0;
  }

  .zip-input::placeholder {
    font-size: 16px;
  }

  .search-btn {
    padding: 16px 25px;
    font-size: 16px;
    min-width: 100px;
    flex-shrink: 0;
  }

  .simple-coverage {
    padding: 3rem 0;
  }

  .simple-coverage-title {
    font-size: 2rem;
    padding: 0 1rem;
  }

  .insurance-competition {
    padding: 3rem 0;
  }

  .competition-content {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .competition-text {
    padding-right: 0;
    order: 2;
  }

  .competition-image {
    order: 1;
  }

  .competition-title {
    font-size: 2rem;
    text-align: center;
  }

  .competition-description {
    font-size: 1rem;
    text-align: center;
  }

  .get-started-btn {
    display: block;
    text-align: center;
    margin: 0 auto;
    max-width: 200px;
  }

  .footer {
    padding: 2rem 0 1.5rem;
  }

  .footer-content {
    padding: 0 1rem;
  }

  .footer-logo-img {
    height: 50px;
  }

  .footer-disclaimer {
    margin-bottom: 1.5rem;
  }

  .footer-disclaimer p {
    font-size: 0.85rem;
  }

  .footer-terms {
    margin-bottom: 1.5rem;
  }

  .footer-terms h3 {
    font-size: 1.2rem;
  }

  .footer-links {
    gap: 0.8rem;
  }

  .footer-link {
    font-size: 0.85rem;
  }

  .link-separator {
    display: none;
  }
}

@media (max-width: 480px) {
  .hero {
    padding: 2rem 0;
  }

  .hero-title {
    font-size: 1.8rem;
  }

  .hero-subtitle {
    font-size: 1rem;
  }

  .search-section {
    margin: 60px auto;
    max-width: 98%;
  }

  .zip-input {
    padding: 14px 16px;
    font-size: 15px;
  }

  .zip-input::placeholder {
    font-size: 15px;
  }

  .search-btn {
    padding: 14px 20px;
    font-size: 15px;
    min-width: 85px;
  }

  .simple-coverage {
    padding: 2.5rem 0;
  }

  .simple-coverage-title {
    font-size: 1.8rem;
    padding: 0 1rem;
  }

  .insurance-competition {
    padding: 2rem 0;
  }

  .competition-title {
    font-size: 1.8rem;
  }

  .competition-description {
    font-size: 0.95rem;
  }

  .get-started-btn {
    padding: 0.8rem 1.5rem;
    font-size: 1rem;
  }

  .footer {
    padding: 1.5rem 0 1rem;
  }

  .footer-logo-img {
    height: 45px;
  }

  .footer-disclaimer p {
    font-size: 0.8rem;
  }

  .footer-terms h3 {
    font-size: 1.1rem;
  }

  .california-notice,
  .do-not-sell {
    font-size: 0.85rem;
  }

  .footer-copyright p {
    font-size: 0.8rem;
  }

  .footer-link {
    font-size: 0.8rem;
  }
}
</style>
